/* "Take a tour": a full-screen gallery of the building. Swipe or scroll on phones, arrows or keys on desktop. */
(function () {
  var dlg = document.getElementById("tour");
  if (!dlg) return;
  var track = dlg.querySelector("[data-tour-track]");
  var slides = [].slice.call(track.children);
  var cur = 0;
  var go = function (i, smooth) {
    cur = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: slides[cur].offsetLeft, behavior: smooth === false ? "auto" : "smooth" });
  };
  var open = function (i) {
    if (typeof dlg.showModal === "function") dlg.showModal(); else dlg.setAttribute("open", "");
    document.documentElement.classList.add("tour-open");
    requestAnimationFrame(function () { go(i, false); });
  };
  var close = function () { if (dlg.open) dlg.close(); };
  dlg.addEventListener("close", function () { document.documentElement.classList.remove("tour-open"); });
  document.addEventListener("click", function (e) {
    var o = e.target.closest("[data-tour-open]");
    if (o) { e.preventDefault(); open(+o.getAttribute("data-tour-open") - 1); return; }
    if (!dlg.open) return;
    var g = e.target.closest("[data-tour-go]");
    if (g) go(cur + +g.getAttribute("data-tour-go"));
    else if (e.target.closest("[data-tour-close]")) close();
  });
  dlg.addEventListener("keydown", function (e) {
    if (e.key === "ArrowRight") { e.preventDefault(); go(cur + 1); }
    else if (e.key === "ArrowLeft") { e.preventDefault(); go(cur - 1); }
  });
  var t = null;
  track.addEventListener("scroll", function () {
    clearTimeout(t);
    t = setTimeout(function () { cur = Math.round(track.scrollLeft / track.clientWidth); }, 80);
  }, { passive: true });
})();
